/**
 * DDCountryCodes — 电话区号表（组团游 / 定制游留咨弹窗共用）
 *
 * 数据格式：[区号, 国家/地区 ISO 3166-1 二字代码, 国家/地区名称]，例如
 *   ['+86', 'CN', 'China']
 *
 * 维护方式
 *   · 一个区号对应多个国家/地区时（+1 北美编号计划、+44 英国及皇家属地、
 *     +7 俄罗斯/哈萨克斯坦、+262 留尼汪/马约特），每个国家/地区各占一行。
 *   · 列表按名称 A→Z 排列（locale 排序）。导出时还会再排一次，所以新增条目
 *     直接追加到末尾也不会打乱顺序。
 *   · 下拉选项文案是「ISO 代码 (+区号)」，例如 CN (+86)，由弹窗组件拼出；
 *     第三列国家名称只作为数据保留，不直接显示。
 *
 * 使用方式
 *   在弹窗脚本之前加载一次（defer 脚本按文档顺序执行）：
 *     <script src="{{ 'dd-country-codes.js' | asset_url }}" defer="defer"></script>
 *   然后读 window.DDCountryCodes；弹窗组件在渲染时现取，不缓存。
 */
;(function () {
  'use strict'

  // 页面里被加载多次时直接退出，保持只有一份
  if (window.DDCountryCodes) return

  var COUNTRIES = [
    ['+93', 'AF', 'Afghanistan'],
    ['+355', 'AL', 'Albania'],
    ['+213', 'DZ', 'Algeria'],
    ['+1', 'AS', 'American Samoa'],
    ['+376', 'AD', 'Andorra'],
    ['+244', 'AO', 'Angola'],
    ['+1', 'AI', 'Anguilla'],
    ['+1', 'AG', 'Antigua and Barbuda'],
    ['+54', 'AR', 'Argentina'],
    ['+374', 'AM', 'Armenia'],
    ['+297', 'AW', 'Aruba'],
    ['+61', 'AU', 'Australia'],
    ['+43', 'AT', 'Austria'],
    ['+994', 'AZ', 'Azerbaijan'],
    ['+1', 'BS', 'Bahamas'],
    ['+973', 'BH', 'Bahrain'],
    ['+880', 'BD', 'Bangladesh'],
    ['+1', 'BB', 'Barbados'],
    ['+375', 'BY', 'Belarus'],
    ['+32', 'BE', 'Belgium'],
    ['+501', 'BZ', 'Belize'],
    ['+229', 'BJ', 'Benin'],
    ['+1', 'BM', 'Bermuda'],
    ['+975', 'BT', 'Bhutan'],
    ['+591', 'BO', 'Bolivia'],
    ['+387', 'BA', 'Bosnia and Herzegovina'],
    ['+267', 'BW', 'Botswana'],
    ['+55', 'BR', 'Brazil'],
    ['+1', 'VG', 'British Virgin Islands'],
    ['+673', 'BN', 'Brunei'],
    ['+359', 'BG', 'Bulgaria'],
    ['+226', 'BF', 'Burkina Faso'],
    ['+257', 'BI', 'Burundi'],
    ['+855', 'KH', 'Cambodia'],
    ['+237', 'CM', 'Cameroon'],
    ['+1', 'CA', 'Canada'],
    ['+238', 'CV', 'Cape Verde'],
    ['+1', 'KY', 'Cayman Islands'],
    ['+236', 'CF', 'Central African Republic'],
    ['+235', 'TD', 'Chad'],
    ['+56', 'CL', 'Chile'],
    ['+86', 'CN', 'China'],
    ['+57', 'CO', 'Colombia'],
    ['+269', 'KM', 'Comoros'],
    ['+242', 'CG', 'Congo'],
    ['+682', 'CK', 'Cook Islands'],
    ['+506', 'CR', 'Costa Rica'],
    ['+225', 'CI', 'Côte d\'Ivoire'],
    ['+385', 'HR', 'Croatia'],
    ['+53', 'CU', 'Cuba'],
    ['+599', 'CW', 'Curaçao'],
    ['+357', 'CY', 'Cyprus'],
    ['+420', 'CZ', 'Czechia'],
    ['+45', 'DK', 'Denmark'],
    ['+253', 'DJ', 'Djibouti'],
    ['+1', 'DM', 'Dominica'],
    ['+1', 'DO', 'Dominican Republic'],
    ['+243', 'CD', 'DR Congo'],
    ['+593', 'EC', 'Ecuador'],
    ['+20', 'EG', 'Egypt'],
    ['+503', 'SV', 'El Salvador'],
    ['+240', 'GQ', 'Equatorial Guinea'],
    ['+291', 'ER', 'Eritrea'],
    ['+372', 'EE', 'Estonia'],
    ['+268', 'SZ', 'Eswatini'],
    ['+251', 'ET', 'Ethiopia'],
    ['+500', 'FK', 'Falkland Islands'],
    ['+298', 'FO', 'Faroe Islands'],
    ['+679', 'FJ', 'Fiji'],
    ['+358', 'FI', 'Finland'],
    ['+33', 'FR', 'France'],
    ['+594', 'GF', 'French Guiana'],
    ['+689', 'PF', 'French Polynesia'],
    ['+241', 'GA', 'Gabon'],
    ['+220', 'GM', 'Gambia'],
    ['+995', 'GE', 'Georgia'],
    ['+49', 'DE', 'Germany'],
    ['+233', 'GH', 'Ghana'],
    ['+350', 'GI', 'Gibraltar'],
    ['+30', 'GR', 'Greece'],
    ['+299', 'GL', 'Greenland'],
    ['+1', 'GD', 'Grenada'],
    ['+590', 'GP', 'Guadeloupe'],
    ['+1', 'GU', 'Guam'],
    ['+502', 'GT', 'Guatemala'],
    ['+44', 'GG', 'Guernsey'],
    ['+224', 'GN', 'Guinea'],
    ['+245', 'GW', 'Guinea-Bissau'],
    ['+592', 'GY', 'Guyana'],
    ['+509', 'HT', 'Haiti'],
    ['+504', 'HN', 'Honduras'],
    ['+852', 'HK', 'Hong Kong'],
    ['+36', 'HU', 'Hungary'],
    ['+354', 'IS', 'Iceland'],
    ['+91', 'IN', 'India'],
    ['+62', 'ID', 'Indonesia'],
    ['+98', 'IR', 'Iran'],
    ['+964', 'IQ', 'Iraq'],
    ['+353', 'IE', 'Ireland'],
    ['+44', 'IM', 'Isle of Man'],
    ['+972', 'IL', 'Israel'],
    ['+39', 'IT', 'Italy'],
    ['+1', 'JM', 'Jamaica'],
    ['+81', 'JP', 'Japan'],
    ['+44', 'JE', 'Jersey'],
    ['+962', 'JO', 'Jordan'],
    ['+7', 'KZ', 'Kazakhstan'],
    ['+254', 'KE', 'Kenya'],
    ['+686', 'KI', 'Kiribati'],
    ['+383', 'XK', 'Kosovo'],
    ['+965', 'KW', 'Kuwait'],
    ['+996', 'KG', 'Kyrgyzstan'],
    ['+856', 'LA', 'Laos'],
    ['+371', 'LV', 'Latvia'],
    ['+961', 'LB', 'Lebanon'],
    ['+266', 'LS', 'Lesotho'],
    ['+231', 'LR', 'Liberia'],
    ['+218', 'LY', 'Libya'],
    ['+423', 'LI', 'Liechtenstein'],
    ['+370', 'LT', 'Lithuania'],
    ['+352', 'LU', 'Luxembourg'],
    ['+853', 'MO', 'Macao'],
    ['+261', 'MG', 'Madagascar'],
    ['+265', 'MW', 'Malawi'],
    ['+60', 'MY', 'Malaysia'],
    ['+960', 'MV', 'Maldives'],
    ['+223', 'ML', 'Mali'],
    ['+356', 'MT', 'Malta'],
    ['+692', 'MH', 'Marshall Islands'],
    ['+596', 'MQ', 'Martinique'],
    ['+222', 'MR', 'Mauritania'],
    ['+230', 'MU', 'Mauritius'],
    ['+262', 'YT', 'Mayotte'],
    ['+52', 'MX', 'Mexico'],
    ['+691', 'FM', 'Micronesia'],
    ['+373', 'MD', 'Moldova'],
    ['+377', 'MC', 'Monaco'],
    ['+976', 'MN', 'Mongolia'],
    ['+382', 'ME', 'Montenegro'],
    ['+1', 'MS', 'Montserrat'],
    ['+212', 'MA', 'Morocco'],
    ['+258', 'MZ', 'Mozambique'],
    ['+95', 'MM', 'Myanmar'],
    ['+264', 'NA', 'Namibia'],
    ['+674', 'NR', 'Nauru'],
    ['+977', 'NP', 'Nepal'],
    ['+31', 'NL', 'Netherlands'],
    ['+687', 'NC', 'New Caledonia'],
    ['+64', 'NZ', 'New Zealand'],
    ['+505', 'NI', 'Nicaragua'],
    ['+227', 'NE', 'Niger'],
    ['+234', 'NG', 'Nigeria'],
    ['+683', 'NU', 'Niue'],
    ['+672', 'NF', 'Norfolk Island'],
    ['+850', 'KP', 'North Korea'],
    ['+389', 'MK', 'North Macedonia'],
    ['+1', 'MP', 'Northern Mariana Islands'],
    ['+47', 'NO', 'Norway'],
    ['+968', 'OM', 'Oman'],
    ['+92', 'PK', 'Pakistan'],
    ['+680', 'PW', 'Palau'],
    ['+970', 'PS', 'Palestine'],
    ['+507', 'PA', 'Panama'],
    ['+675', 'PG', 'Papua New Guinea'],
    ['+595', 'PY', 'Paraguay'],
    ['+51', 'PE', 'Peru'],
    ['+63', 'PH', 'Philippines'],
    ['+48', 'PL', 'Poland'],
    ['+351', 'PT', 'Portugal'],
    ['+1', 'PR', 'Puerto Rico'],
    ['+974', 'QA', 'Qatar'],
    ['+262', 'RE', 'Réunion'],
    ['+40', 'RO', 'Romania'],
    ['+7', 'RU', 'Russia'],
    ['+250', 'RW', 'Rwanda'],
    ['+1', 'KN', 'Saint Kitts and Nevis'],
    ['+1', 'LC', 'Saint Lucia'],
    ['+508', 'PM', 'Saint Pierre and Miquelon'],
    ['+1', 'VC', 'Saint Vincent and the Grenadines'],
    ['+685', 'WS', 'Samoa'],
    ['+378', 'SM', 'San Marino'],
    ['+239', 'ST', 'São Tomé and Príncipe'],
    ['+966', 'SA', 'Saudi Arabia'],
    ['+221', 'SN', 'Senegal'],
    ['+381', 'RS', 'Serbia'],
    ['+248', 'SC', 'Seychelles'],
    ['+232', 'SL', 'Sierra Leone'],
    ['+65', 'SG', 'Singapore'],
    ['+1', 'SX', 'Sint Maarten'],
    ['+421', 'SK', 'Slovakia'],
    ['+386', 'SI', 'Slovenia'],
    ['+677', 'SB', 'Solomon Islands'],
    ['+252', 'SO', 'Somalia'],
    ['+27', 'ZA', 'South Africa'],
    ['+82', 'KR', 'South Korea'],
    ['+211', 'SS', 'South Sudan'],
    ['+34', 'ES', 'Spain'],
    ['+94', 'LK', 'Sri Lanka'],
    ['+249', 'SD', 'Sudan'],
    ['+597', 'SR', 'Suriname'],
    ['+46', 'SE', 'Sweden'],
    ['+41', 'CH', 'Switzerland'],
    ['+963', 'SY', 'Syria'],
    ['+886', 'TW', 'Taiwan'],
    ['+992', 'TJ', 'Tajikistan'],
    ['+255', 'TZ', 'Tanzania'],
    ['+66', 'TH', 'Thailand'],
    ['+670', 'TL', 'Timor-Leste'],
    ['+228', 'TG', 'Togo'],
    ['+690', 'TK', 'Tokelau'],
    ['+676', 'TO', 'Tonga'],
    ['+1', 'TT', 'Trinidad and Tobago'],
    ['+216', 'TN', 'Tunisia'],
    ['+90', 'TR', 'Türkiye'],
    ['+993', 'TM', 'Turkmenistan'],
    ['+1', 'TC', 'Turks and Caicos Islands'],
    ['+688', 'TV', 'Tuvalu'],
    ['+1', 'VI', 'U.S. Virgin Islands'],
    ['+256', 'UG', 'Uganda'],
    ['+380', 'UA', 'Ukraine'],
    ['+971', 'AE', 'United Arab Emirates'],
    ['+44', 'GB', 'United Kingdom'],
    ['+1', 'US', 'United States'],
    ['+598', 'UY', 'Uruguay'],
    ['+998', 'UZ', 'Uzbekistan'],
    ['+678', 'VU', 'Vanuatu'],
    ['+379', 'VA', 'Vatican City'],
    ['+58', 'VE', 'Venezuela'],
    ['+84', 'VN', 'Vietnam'],
    ['+681', 'WF', 'Wallis and Futuna'],
    ['+967', 'YE', 'Yemen'],
    ['+260', 'ZM', 'Zambia'],
    ['+263', 'ZW', 'Zimbabwe'],
  ]

  // 源表已按 A→Z 排好；导出时再排一次，避免后来的人追加时插错位置
  COUNTRIES.sort(function (a, b) { return a[2].localeCompare(b[2], 'en') })

  window.DDCountryCodes = COUNTRIES
})()
